export type VideoStats = {
  path: string;
  channel: number;
  live: boolean;
  waiting: boolean;
  status: string;
  ws: string;
  received: number;
  decoded: number;
  rendered: number;
  dropped: number;
  latencySec: number;
  firstVideoAt: number;
};

const empty = (): VideoStats => ({
  path: "",
  channel: 0,
  live: false,
  waiting: false,
  status: "idle",
  ws: "idle",
  received: 0,
  decoded: 0,
  rendered: 0,
  dropped: 0,
  latencySec: 0,
  firstVideoAt: 0,
});

let latest: VideoStats = empty();

export function publishVideoStats(partial: Partial<VideoStats>): VideoStats {
  latest = { ...latest, ...partial };
  try {
    (window as unknown as { __dashcamVideo?: VideoStats }).__dashcamVideo = latest;
  } catch {
    /* ignore */
  }
  return latest;
}

export function videoStats(): VideoStats {
  return latest;
}
